import { render, staticRenderFns } from "./TheModalPieza.vue?vue&type=template&id=5f2020d2&scoped=true&"
import script from "./TheModalPieza.vue?vue&type=script&lang=js&"
export * from "./TheModalPieza.vue?vue&type=script&lang=js&"
import style0 from "./TheModalPieza.vue?vue&type=style&index=0&id=5f2020d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2020d2",
  null
  
)

export default component.exports